import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Header } from './Header';
import Logo2 from '@/assets/img/logo_login.png';
import { Industry, Personal, Result } from './Steps';
import { StepsNavigation } from '@/components/ui/StepsNavigation';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import { DIRECTION } from '@/components/ui/StepsNavigation/types';
import * as S from './styles';

const { useForm } = Form;

export function Content() {
	const [form] = useForm();
	const { currentStep, onUpdateCurrentStep } = useCalculateReturnOfInvestments();

	const steps = [
		{
			sequence: 1,
			description: I18n.get('Personal information'),
			component: <Personal />
		},
		{
			sequence: 2,
			description: I18n.get('Industry information'),
			component: <Industry />
		},
		{
			sequence: 3,
			description: I18n.get('Result'),
			component: <Result />
		}
	];

	async function handleOnClickStep(step: number): Promise<void> {
		if (step >= currentStep) return;
		onUpdateCurrentStep(step);
	}

	return (
		<Form form={form}>
			<Row justify="center" gutter={[0, 60]}>
				<Col span={24}>
					<S.LogoWrapper>
						<S.LogoImage src={Logo2} alt="Kinebot Logo" />
					</S.LogoWrapper>
				</Col>
				<Col span={24}>
					<Row justify="center" gutter={[0, 20]} style={{ paddingBottom: '80px' }}>
						<Col span={24}>
							<Header />
						</Col>
						<Col span={24}>
							<Row justify="center">
								<Col span={24}>
									<StepsNavigation
										steps={steps}
										responsive={false}
										isComplete={false}
										isConsolidated={false}
										currentStep={currentStep}
										direction={DIRECTION.HORIZONTAL}
										onStepNagivationClick={handleOnClickStep}
									/>
								</Col>
								<Col style={{ display: 'flex', justifyContent: 'center' }}>
									<S.StepsContainer>{steps[currentStep]?.component}</S.StepsContainer>
								</Col>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
		</Form>
	);
}
